import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Buttons/Button";

const NoticePrevNext = ({ prev, next, setListId }) => {
  const navigate = useNavigate();

  return (
    <>
      <ul className="flex flex-col gap-2.5 py-3 mb-10 border-y border-neutral-100">
        {prev && (
          <li className="flex">
            <p className="text-sm font-medium leading-6 shrink-0 w-14 text-neutral-500">
              이전글
            </p>
            <button
              onClick={() => setListId(prev.id)}
              className="text-base font-medium truncate"
            >
              {prev.title}
            </button>
          </li>
        )}
        {next && (
          <li className="flex">
            <p className="text-sm font-medium leading-6 shrink-0 w-14 text-neutral-500">
              다음글
            </p>
            <button
              onClick={() => setListId(next.id)}
              className="text-base font-medium truncate text-neutral-950"
            >
              {next.title}
            </button>
          </li>
        )}
      </ul>
      <div className="flex justify-end">
        <div className="w-2/5">
          <Button
            size="sm"
            onClick={() => {
              navigate(-1);
            }}
          >
            목록으로
          </Button>
        </div>
      </div>
    </>
  );
};

export default NoticePrevNext;
